import React from 'react'
import Title from '../Shared/Title/Title'
import * as styles from './sectionImageCards.module.scss'
import { GatsbyImage } from 'gatsby-plugin-image'
import { RichText } from '../Shared/RichText/RichText'


const SectionImageCards = ({ gridItems }) => {
    const { title, cards, backgroundImage } = gridItems
    return (
        <div className='container' style={{ background: backgroundImage ? `url(${backgroundImage.file?.url}) no-repeat center center / cover` : "" }}>
            <div className='container-lg'>
                <div>
                    <h2 className={styles.imageCardTitle}><Title title={title} /></h2>
                </div>
                <div className={styles.cardWrapper}>
                    {cards.map((card: any, id: number) => {
                        const { image, title, description } = card
                        return (
                            <div className={styles.card} >
                                <div>
                                    <GatsbyImage
                                        image={image.gatsbyImageData}
                                        alt={`${title || card.title} image`}
                                        className = {styles.cardImage}
                                    />
                                </div>
                                <div className={styles.cardDetail}>
                                    <div className={styles.cardBox}>
                                        <div className={styles.boxTitle}>{title}</div>
                                        <div className={styles.boxPara}><RichText content={description} /></div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default SectionImageCards